import { checkLeadboxSpamFilter } from './check-spam';
import { generateRecaptchaToken, getRecaptchaScore, loadGoogleRecaptcha } from './recaptcha';

const RECAPTCHA_ACTION = 'FORM_SUBMIT';

export function initSpamGuard({ recaptchaEnabled }) {
  if (recaptchaEnabled) {
    loadGoogleRecaptcha();
  }
}

export async function runPreSubmitCheck({ globalState, cachedToken, cachedScore }) {
  const { recaptchaEnabled, requireSpamCheck, countryCode, nature } = globalState.globalConfig;

  const recaptchaToken = recaptchaEnabled
    ? cachedToken === null
      ? await generateRecaptchaToken(RECAPTCHA_ACTION)
      : cachedToken
    : null;

  if (!requireSpamCheck) {
    return {
      recaptchaToken,
      recaptchaScore: null,
      requiresSmsVerification: false,
      ranSpamCheck: false,
    };
  }

  const recaptchaScore = recaptchaEnabled
    ? cachedScore === null
      ? await getRecaptchaScore(recaptchaToken, RECAPTCHA_ACTION)
      : cachedScore
    : null;

  const requiresSmsVerification = await safeCheckSpam(
    globalState,
    countryCode,
    nature,
    recaptchaScore
  );

  return {
    recaptchaToken,
    recaptchaScore,
    requiresSmsVerification,
    ranSpamCheck: true,
  };
}

async function safeCheckSpam(globalState, countryCode, nature, score) {
  try {
    return await checkLeadboxSpamFilter(globalState, countryCode, nature, score);
  } catch (e) {
    console.error(e);
    return false;
  }
}
